import AppConfig from "@/constants/AppConfig";
import {
	PaymentLinkClicked
} from "@/telemetry";

const _getters = {
	showTrialEndDialog( state, getters, rootState, rootGetters ) {
		const userProfile = rootGetters[ "userProfile/userProfile" ];
		if ( !userProfile ) {
			return false;
		}
		return userProfile?.isFreeTrialExpired &&
			userProfile?.showPaymentOption;
	},
};

const actions = {
	tryShowTrialEndDialog( { commit, getters, } ) {
		if ( !getters.showTrialEndDialog ) {
			return;
		}
		commit( "confirmationDialog/requestUserConfirmation", {
			metadata: { },
			isPersistent: true,
			dialog: {
				contentClass: "app-confirmation-dialog trial-end-dialog",
			},
			header: {
				class: "trial-end-dialog__header text-ms2",
				text: "common.TrialEndDialog_title",
			},
			body: {
				contentClass: "trial-end-dialog__body text-ms0",
				text: "common.TrialEndDialog_bodyHTML",
			},
			confirm: {
				action: "trialEndDialog/subscribe",
				buttonText: "common.TrialEndDialog_subscribeNowButton",
				class: "app-confirmation-dialog__confirm-button trial-end-dialog__subscribe",
				close: false,
			},
			cancel: {
				buttonText: "", // hide the cancel button
			},
		}, { root: true, } );
	},
	schedule() {
		window.open( AppConfig.coachingLink, "_blank" );
	},
	chat() {
		// HACK: invoking intercom direction because we currently have no way to
		// access our intercom module here without a significant refactor
		if ( window.Intercom ) {
			// eslint-disable-next-line new-cap
			window.Intercom( "show" );
		}
	},
	async subscribe( { rootGetters, } ) {
		const userProfile = rootGetters[ "userProfile/userProfile" ];
		const { personId, email, } = userProfile;
		const { stripePaymentLink, } = AppConfig;
		const event = new PaymentLinkClicked( "Trial End Dialog" );
		await event.submit();
		const paymentLink = `${ stripePaymentLink }?client_reference_id=${ personId }&prefilled_email=${ email }`;
		window.location.assign( paymentLink );
	},
};

export default {
	state: {},
	getters: _getters,
	mutations: {},
	actions,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/trialEndDialog.js